import React from "react";
import { motion } from "framer-motion";

const projects = [
  {
    id: 1,
    title: "Housing Price Prediction",
    description:
      "Applied advanced data mining techniques to predict housing prices by identifying significant predictors such as area, number of bedrooms, and location. Built a Multiple Linear Regression model, conducted data preprocessing, and created visualizations to analyze property features and housing prices.",
    image: "/assets/sample.jpg", // Replace with actual image path
    github: "https://github.com/srideepthi-vootla/Housing_Price_Prediction",
  },
  {
    id: 2,
    title: "Data Science Job Salary Trends",
    description:
      "Developed interactive Tableau visualizations to analyze and present global trends in data science job salaries. Conducted a detailed analysis based on experience levels, job roles, and geographic regions, enabling a deeper understanding of hiring trends in the data science field.",
    image: "/assets/sample.jpg", // Replace with actual image path
    github: "https://github.com/srideepthi-vootla/Data-Science-Job-Salary-Trends-",
  },
  {
    id: 3,
    title: "Game Sales Dashboard",
    description:
      "Conducted an in-depth analysis of video game sales data to uncover trends across regions, platforms, genres, and publishers. Designed and developed interactive Tableau dashboards to highlight key insights, showcasing sales patterns and regional preferences, facilitating data-driven decisions in the gaming industry.",
    image: "/assets/sample.jpg", // Replace with actual image path
    github: "https://github.com/srideepthi-vootla/Game-Sales-Dashboard",
  },
  {
    id: 4,
    title: "NYC Taxi Data Analysis",
    description:
      "Performed an exploratory data analysis of NYC taxi trip data to identify patterns in trip durations, distances, and fares. Processed and cleaned large datasets using Python and Pandas and developed visualizations to effectively communicate insights about taxi usage and fare trends.",
    image: "/assets/sample.jpg", // Replace with actual image path
    github: "https://github.com/srideepthi-vootla/NYC-Taxi-Data-Analysis",
  },
];

const Projects = () => {
  return (
    <section id="projects" className="py-16 bg-gray-50">
      <div className="container mx-auto px-6">
        
        {/* 🔥 Animated Projects Title */}
        <motion.h2
          className="text-4xl md:text-3xl font-extrabold text-center text-gray-900 mb-10 uppercase tracking-wide"
          initial={{ opacity: 0, y: -20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 1 }}
        >
          <span className="text-purple-600">P R O J E C T S</span>
        </motion.h2>

        {/* 📌 Projects Grid */}
        <div className="flex flex-col gap-12">
          {projects.map((project, index) => (
            <motion.div
              key={project.id}
              className={`flex flex-col md:flex-row items-center justify-between bg-white p-8 md:p-6 rounded-xl shadow-lg transition-transform duration-300 hover:scale-105 hover:shadow-2xl ${
                index % 2 === 0 ? "md:flex-row" : "md:flex-row-reverse"
              }`}
              whileHover={{ scale: 1.05 }}
            >
              {/* 🖼️ Project Image */}
              <div className="w-full md:w-1/2 flex justify-center">
                <img
                  src={project.image}
                  alt={project.title}
                  className="w-4/5 md:w-3/4 rounded-lg shadow-lg"
                />
              </div>

              {/* 📄 Project Info */}
              <div className="w-full md:w-1/2 text-center md:text-left px-6">
                <h3 className="text-3xl md:text-2xl font-semibold">{project.title}</h3>
                <p className="text-gray-600 my-4">{project.description}</p>
                {project.github && (
                  <a
                    href={project.github}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="inline-block px-6 py-3 mt-2 text-lg font-semibold text-white bg-purple-600 hover:bg-purple-700 rounded-lg transition-all"
                  >
                    View on GitHub
                  </a>
                )}
              </div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Projects;